const mediaSwiper = new Swiper('.text-with-media .media-column .image-swiper', {
    // Optional parameters
    loop: true,
    slidesPerView: 1,
    autoplay: true,
    allowTouchMove: true, // Enable touch/swipe gestures
    navigation: {
        nextEl: '.text-with-media .media-column .swiper-controls .next',
        prevEl: '.text-with-media .media-column .swiper-controls .prev',
    },
});